<template style="">
  <div class="User_analysis">

    <el-row :gutter="20">
      <el-col :span="9">
        <div class="grid-content bg-purple">
          <h2>用户访问走势</h2>
          <div id="main" ref="myechart" style="width: 90%;height:300px;margin-left: 3%;"></div>
        </div>
      </el-col>

      <el-col :span="15">
        <div class="grid-content bg-purple">
          <div id="main" ref="myechart2" style="width: 32%;height:340px;margin-left: 1%;float: left;margin-top:20px"></div>
          <div ref="education" style="width:32%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
          <div ref="education2" style="width:32%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
          <!-- <div id="main" ref="myechart2" style="width: 32%;height:300px;margin-left: 1%;float: left;"></div>
          <div id="main" ref="myechart2" style="width: 32%;height:300px;margin-left: 1%;float: left;"></div> -->
        </div>
      </el-col>
    </el-row>

    <div class="nav">
      <h2>用户行为数据列表</h2>
      <span style="margin-left: 14px;">统计时间：</span>
      <el-date-picker @change="time3()" v-model="value5" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :picker-options="pickerOptions" ></el-date-picker> 至
      <el-date-picker :picker-options="pickerOptions" @change="time3()" v-model="value6" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期"></el-date-picker>
      <el-button type="primary" style="margin-left: 20px;margin-top: 2px;" @click="resfun()">重置</el-button>
      <el-button type="primary" style="margin-left: 20px;margin-top: 2px;" @click="resetfun()">导出</el-button>
      <el-table :data="tableData" style="width:98%;margin-left:1%;margin-top:10px;">
        <el-table-column prop="CreateTime"   label="统计时间">  </el-table-column>
        <el-table-column prop="VisitNum"     label="访问用户数"></el-table-column>
        <el-table-column prop="NewQnty"      label="新增用户数"></el-table-column>
        <el-table-column prop="HotQnty"      label="活跃用户数"></el-table-column>
        <el-table-column prop="LostQnty"     label="流失用户数"></el-table-column>
        <el-table-column prop="BackQnty"     label="回访用户数"></el-table-column>
        <el-table-column prop="MaterialName" label="热门内容">  </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      value5: '',
      value6: '',
      data:[],
      alldata:[],
      tableData: [],
      pageIndex:1,
      pageSize: 10,
      UndoCount: 0,
    }
  },
  mounted() {
    this.a1();
    this.a2();
    this.loading();
    this.$Http_Post('management/publicizeEduAndSex', {}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.alldata = res.Data;
        this.education()
        this.education2()
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  methods: {
    // 参加学历占比
    education(){
      var myChart = this.$echarts.init(this.$refs.education);
      var option = {
        title: {
          text: '阅读量(学历)',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D', '#557CD9', '#E3B540'],
        legend: {
          top: '86%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            data: [
              { value: this.alldata.edu.benke, name: '本科生'},
              { value: this.alldata.edu.suosi, name: '硕士生'},
              { value: this.alldata.edu.bosi,  name: '博士生'},
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    education2(){
      var myChart = this.$echarts.init(this.$refs.education2);
      var option = {
        title: {
          text: '阅读量(性别)',
          left: '20px',
          top: '10px',
        },
        tooltip: {
          trigger: 'item'
        },
        color:['#93C22D', '#557CD9'],
        legend: {
          top: '86%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            data: [
              { value: this.alldata.sex.boy, name: '男'},
              { value: this.alldata.sex.girl, name: '女'},
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
        
      });
    },
    resfun() {
      this.value5 = '',
      this.value6 = '',
      this.pageIndex = 1,
      this.pageSize= 10,
      this.loading();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    time3() {
      if (this.value5 && this.value6) {
        this.pageIndex = 1;
        this.loading();
      }
    },
    resetfun(){
      this.$Http_Post('management/userBehaviorList', {PageIndex: this.pageIndex, PageSize: this.pageSize, StartTime:this.value5, EndTime: this.value6,ExcelFlag:'1' }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    loading() {
      this.$Http_Post('management/userBehaviorList', {PageIndex: this.pageIndex, PageSize: this.pageSize, StartTime:this.value5, EndTime: this.value6 }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.UndoCount = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    a1() {
      this.$Http_Post('management/visitTrend', {StartTime:this.value1,EndTime:this.value2}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          var myChart = this.$echarts.init(this.$refs.myechart);
          var option = {
            tooltip: {
              trigger: 'axis'
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            color: ['#5470c6','#fc8251','#91cd77','#ef6567','#f9c956'],
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: res.Data.month
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: '访问用户数',
                type: 'line',
                data: res.Data.visitNum
              },
              {
                name: '新增用户数',
                type: 'line',
                data: res.Data.addNum
              },
              {
                name: '活跃用户数',
                type: 'line',
                data: res.Data.activeNum
              },
              {
                name: '流失用户数',
                type: 'line',
                data: res.Data.lossNum
              },
              {
                name: '回访用户数',
                type: 'line',
                data: res.Data.followUpNum
              }
            ]
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    a2() {
      this.$Http_Post('management/hotTheme', { StartTime: this.value3, EndTime: this.value4}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          var myChart2 = this.$echarts.init(this.$refs.myechart2);
          var option = {
            title: {
              text: '热门标签排行',
              left: '20px',
              top: '10px',
            },
            tooltip: {
              trigger: 'item'
            },
            color:['#93C22D', '#257CD9', '#63C62D', '#907CD9'],
            legend: {
              top: '86%',
              left: 'center',
              selectedMode: false
            },
            series: [
              {
                type: 'pie',
                radius: ['40%', '60%'],
                data: [
                  {value:res.Data[0].ReadingVolume,name:res.Data[0].MaterialName},
                  {value:res.Data[1].ReadingVolume,name:res.Data[1].MaterialName},
                  {value:res.Data[2].ReadingVolume,name:res.Data[2].MaterialName},
                  {value:res.Data[3].ReadingVolume,name:res.Data[3].MaterialName},
                ]
              }
            ]
          };
          myChart2.setOption(option);
          window.addEventListener("resize", function () {
            myChart2.resize();
          });
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
}
</script>
<style>
.User_analysis{width: 100%;background-color: #fff;}
.User_analysis .bg-purple{height: 400px;}
.User_analysis h2{padding: 14px;font-size: 18px;}
.User_analysis .pm li{font-size: 14px;margin-top: 4px;}
.User_analysis .nav{height: calc(100% - 420px);margin-top: 20px;background-color: rgb(255, 255, 255);min-height: 730px;}
</style>
